import './ui/tokens.css';
import { appState } from './state';
import { renderApp } from './app';
import { installGlobalErrorHandlers } from './services/web-diagnostics';

// Faz V U8.5: browser hata yakalayıcıları — JS exception + Promise reject
// backend'e POST edilir, operator 'docker logs photonremote-api | grep
// WEB-LOG' ile uzaktan görür. User'dan F12 console kopyalama istemeye
// gerek kalmaz.
installGlobalErrorHandlers();

const root = document.getElementById('app');
if (!root) {
  throw new Error('#app root missing in index.html');
}

appState.subscribe(() => renderApp(root));
renderApp(root);
